import React from 'react';
import styles from './DeliveryPage.module.scss';

const DeliveryPage = () => {
    return (
        <div className={styles.container}>
            We value every single customer and every parcel delivery carefully.
            You can always find a best delivery option for your order, such as
            Standard(Save Money), Expedited and Express(Fastest).
        </div>
    );
};

export default DeliveryPage;
